<script>

import * as d3 from 'd3'
import * as topojson from 'topojson'

export default {
    props:{
      locations: {
        type: Array
      },
    },
    data() {
      return {
        csv: null,
        projection: null,
        borders: null,
        countries: [],
        countryRisk: [],
        countryInfo: [],
        offsetX: 50,
        offsetY: 0,
        avgRiskAcc: 0,
        avgRiskCnt: 0,
        viewbox: "0 0 0 0",
        // modalRiskDetailShow:'',
        timer: '',
        settings: {
            strokeColor: "#19B5FF",
            width: 570,
            height: 320
        },
  			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      }
    },
    methods: {
      geoRisk: function() {
        let that = this;
        that.countries.map(function(country) { 
          let countryInfo = that.resolveCountryInfoById(country.id);
          if (countryInfo == undefined) {
            return
          }
          that.locations.map(function(location) {
            if (location.country === countryInfo.nombre) {
              country.class = "neutral"
            }
            if (location.country_code === countryInfo.codalfa2) {
              country.class = "neutral"
            }
          })
        })
      },
      pathGenerator: function(argu) {
          var pgfunc = d3.geoPath().
              projection(this.projection);
          return pgfunc(argu);
      },
      resolveCountryInfoById: function(id) {
          var result;
          this.countryInfo.map(function(country){
              if (country.id == id) { 
                  result = country;
              }
          });
          return result;
      },
      async calculatePath() {
        let that = this
        that.projection = d3.geoMercator()
            .scale(that.settings.width / 2 / Math.PI)
            .scale(100)
            .translate([(that.settings.width / 2) + that.offsetX, (that.settings.height / 2) + that.offsetY])

        await d3.json("https://360secpublic.s3.amazonaws.com/topo/world-110m.json").then(function(world) {
          var countries = topojson.feature(world, world.objects.countries).features;
          that.borders = topojson.mesh(world, world.objects.countries, function(a, b) { return a.id !== b.id; });
          countries.map(function(country) {
            country.class = "normal";
            that.countries.push(country);
          });
        })

        await d3.tsv("https://360secpublic.s3.amazonaws.com/topo/paises.tsv").then(function(countries) {
          countries.map(function(country) {
            that.countryInfo.push(country);
          });          
        })
        this.geoRisk()
      },
      countryNameClickHandlerMap(name, code) {

      },
    },
    mounted () {
        const that = this
        that.$nextTick(() => {
          that.calculatePath();
        })
      },
  }
  </script>

  <template>
    <svg v-bind:width="settings.width" v-bind:height="settings.height" class="svg-map">
      <g class="countries" v-for="(country, index) in countries" v-bind:key="index">
          <path :d="pathGenerator(country)" 
          :class="country.class" 
          @click="countryNameClickHandlerMap(country.name, country.code)" />
      </g>
    </svg>
</template>


<style>
  .svg-map {
    /* background: lightBlue; */
      background: #F6F9FA;

  }

  .countries {
  
    stroke: white;
    stroke-width: 0.2px;

    fill: #D7DBE2;
  }


  .normal {
    color: #D7DBE2;
    fill: #D7DBE2;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }
  
  .neutral {
    color: #03A3FF;
    fill: #03A3FF;
    background-color: #D7DBE2 !important;
    border: 0px !important;
  }

  .high {
    color: #DC001E;
    fill: #DC001E;
    background-color: #DC001E !important;
    border: 0px !important;  
  }

  .medium {
    color: #FECA00;
    fill: #FECA00;
    background-color: #FECA00 !important;
    border: 0px !important;  
  }

  .low {
    color: #01AD00;
    fill: #01AD00;
    background-color: #01AD00 !important;
    border: 0px !important;  
  }
</style>
